import {Expose } from 'class-transformer';

export class ScreenColApiModel {

  @Expose()
  id: string;

  @Expose()
  coordinate: number;

}
